
<template>
  <div class="content-btn-check">
    <button class="chancel-desc-check"
            v-if="approveType !=approveParam.invalidReport"
            @click="commit(false)">拒绝</button>
    <button class="sure-desc-check"
            v-if="approveType !=approveParam.invalidReport"
            @click="commit(true)">批准</button>
    <button class="del-desc-check"
            v-if="approveType ==approveParam.invalidReport"
            @click="del()">删除</button>
  </div>
</template>

<script>
import reopetModel from '../../api/model/visit-report'
import customerModel from '../../api/model/customer'
import { mapState } from 'vuex'
export default {
  name: 'ApproveBottom',
  data() {
    return {}
  },
  components: {},
  props: ['id', 'approveType', 'approveContent'],
  methods: {
    async commit(passOper) {
      var res
      let param = {
        id: this.id,
        isPass: passOper,
      }
      if (this.approveType == this.approveParam.visitReport) {
        if (this.approveContent == '' || this.approveContent == undefined) {
          this.$toast('请输入审批意见')
          return false
        }
        param = {
          id: this.id,
          isPass: passOper,
          approveContent: this.approveContent,
        }
        res = await reopetModel.addApprovedReport(null, param)
      } else if (this.approveType == this.approveParam.customer) {
        res = await customerModel.approvedCustomer(null, param)
      } else {
        this.$toast('系统错误:参数错误')
        return false
      }

      if (res.success) {
        this.$toast('审批结果提交成功')
        this.$router.push({ path: '/approve' })
      } else {
        this.$toast(res.msg)
      }
    },
    async del() {
      this.$dialog
        .confirm({
          title: '删除数据',
          message: '删除操作执行后将不可恢复，确认要删除该条过期数据吗？',
        })
        .then(() => {
          this.delSubmit()
        })
    },
    async delSubmit() {
      const param = {
        id: this.id,
      }
      const res = await reopetModel.delWaitApproveReport(param)
      if (res.success) {
        this.$toast('数据删除成功')
        this.$router.push('/approve')
      }
    },
  },
  computed: {
    ...mapState('systemAbout', ['approveParam']),
  },
}
</script>

<style scoped>
</style>